import styled from 'styled-components';

// Sits above the react-components ModalManager, which uses z-index 100.
const DIALOG_LAYER_Z_INDEX = 101;

const DialogLayer = styled.div`
  position: relative;
  z-index: ${DIALOG_LAYER_Z_INDEX};
`;

export default DialogLayer;



// WEBPACK FOOTER //
// ./components/instruction-hub-feedback/styled.js